<template>
  <div class="recipe">
    <breadcrumb v-bind:path2="path2" v-bind:path1="path1"></breadcrumb>
    <div v-if="this.isLoading" class="recipe-container">
      <div class="page-width">
        <div class="loadmore disableBtn">
          <span>{{ $t('loading')}}</span>
          <i class="loading">
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
          </i>
        </div>
      </div>
    </div>
    <div v-if="!this.isLoading" class="recipe-container">
      <div>
        <h3>{{this.recipe.title}}</h3>
      </div>
      <!-- non mobile view -->
      <div v-if="!this.mobile" class="recipe-content">
        <div class="recipe-left">
          <img :src="recipe.image_file" alt="">
          <p>{{ $t('difficulty') }}: {{this.recipe.difficulty}} </p>
          <p>{{ $t('prepTime') }}: {{this.recipe.prep_time}}</p>
          <p>{{ $t('cookTime') }}: {{this.recipe.cook_time}}</p>
          <p>{{ $t('serves') }}: {{this.recipe.serves}}</p>
        </div>
        <div class="recipe-right">
          <!-- content -->
          <p v-if="recipe.rich_text_description">
            <span v-html="recipe.rich_text_description"></span>
          </p>
          <p><h3>{{ $t('ingredient') }}:</h3></p>
          <p v-if="recipe.rich_text_ingredient">
            <span v-html="recipe.rich_text_ingredient"></span>
          </p>
          <p><h3>{{ $t('direction') }}:</h3></p>
          <p v-if="recipe.rich_text_direction">
            <span v-html="recipe.rich_text_direction"></span>
          </p>
          <!-- videos -->
          <div v-if="this.recipe.videos" class="product-recipe-videos">
            <ul>
              <li v-for="(item, index) in recipe.videos" :key='index'>
                <iframe :src="item" frameborder="0" allowfullscreen></iframe>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- mobile view -->
      <div v-if="this.mobile" class="recipe-content">
        <p>{{ $t('difficulty') }}: {{this.recipe.difficulty}} </p>
        <p>{{ $t('prepTime') }}: {{this.recipe.prep_time}}</p>
        <p>{{ $t('cookTime') }}: {{this.recipe.cook_time}}</p>
        <p>{{ $t('serves') }}: {{this.recipe.serves}}</p>
        <img :src="recipe.image_file" alt="">
        <p v-if="recipe.rich_text_description">
          <span v-html="recipe.rich_text_description"></span>
        </p>
        <p><h3>{{ $t('ingredient') }}:</h3></p>
        <p v-if="recipe.rich_text_ingredient">
          <span v-html="recipe.rich_text_ingredient"></span>
        </p>
        <p><h3>{{ $t('direction') }}:</h3></p>
        <p v-if="recipe.rich_text_direction">
          <span v-html="recipe.rich_text_direction"></span>
        </p>
        <div v-if="this.recipe.videos.length > 0" class="product-recipe-videos">
          <ul>
            <li v-for="(item, index) in recipe.videos" :key='index'>
              <iframe :src="item" frameborder="0" allowfullscreen></iframe>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import moment from 'moment';
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  name: "recipeDetail",
  components: {
    breadcrumb,
  },
  data() {
    return {
      path1: {
        name: this.$t('recipes'),
        path: '/recipes',
      },
      path2: '',
      recipe: {},
      isLoading: false,
    }
  },
  methods: {
    ...mapActions('recipe',['fetchRecipeDetail']),
    ...mapMutations('navbar', ['mobileDevice']),
    getRecipeDetail(id) {
      this.isLoading = true;
      this.fetchRecipeDetail(id)
      .then(res => {
        this.isLoading = false;
        this.recipe = res.data;
        this.recipe.title = this.recipe.title.toUpperCase();
        if (this.recipe.videos) {
          this.recipe.videos = JSON.parse(this.recipe.videos);
        }
        this.path2 = this.recipe.title;
        this.recipe.update_time = moment(String(res.data.update_time)).format('LL');
      })
      .catch(err => {
        this.isLoading = true;
        console.log('err', err)
      })
    },
  },
  mounted() {
    const url = this.$route.fullPath;
    const lastURLSegment = url.substr(url.lastIndexOf('/') + 1);
    const recipeId = this.selectRecipeId || lastURLSegment;
    this.getRecipeDetail(recipeId);
  },
  computed: mapState({
    mobile: state => state.navbar.mobile,
    selectRecipeId: state => state.recipe.selectRecipeId,
  }),
  watch: {
    selectRecipeId: function(newVal, oldVal) {
      this.getRecipeDetail(newVal);
    },
  }
}
</script>

<style scoped lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/recipe.less";
</style>



// WEBPACK FOOTER //
// src/view/Recipe/recipeDetail.vue